<template>
  <div class="mine-tab">
    <div class="mine__header">
      <div class="mine__head">
        <img src="../../../../assets/mine-head.png" />
      </div>
      <div class="mine__name">{{ hadLogin ? mobile : '未登录' }}</div>
      <div v-if="hadLogin" class="mine__btn-login" @click="onPopupLogout">
        退出
      </div>
      <div v-else class="mine__btn-login" @click="onPopupLogin">登录</div>
    </div>
    <div class="mine__content">
      <div class="mine__item">
        <div class="mine__item-points-icon"></div>
        <div class="mine__item-text" @click="onRoutePointseRecord">
          积分明细
        </div>
        <div class="mine__item-arrow"></div>
      </div>
      <div class="mine__item">
        <div class="mine__item-icon"></div>
        <div class="mine__item-text" @click="onRouteExchagneRecord">
          兑换记录
        </div>
        <div class="mine__item-arrow"></div>
      </div>
      <div class="mine__tip">
        <div class="mine__tip-title">服务提供方</div>
        <div class="mine__tip-content">
          该权益由北京悠享互联信息技术有限公司提供，如使用问题请咨询全国
          客服热线：4000-852-818（客服工作时间：周一至周日9:00-18:00）
        </div>
      </div>
    </div>
    <van-dialog
      v-model:show="isLoginPopupVisble"
      show-cancel-button
      confirm-button-text="立即登录"
      :beforeClose="validateLogin"
      @confirm="onLogin"
    >
      <div class="login-form">
        <div class="login-title">登录</div>
        <div class="login-row">
          <div class="login-label">手机号后六位：</div>
          <input
            class="login-input"
            pattern="[0-9]*"
            type="tel"
            placeholder="请输入手机号后六位"
            v-model="mobile"
            @input="onMobileInput"
          />
        </div>
        <div class="login-row">
          <div class="login-label">身份证号后六位：</div>
          <input
            class="login-input"
            type="text"
            placeholder="请输入身份证号后六位"
            v-model="credentials"
            @input="onCredentialsInput"
          />
        </div>
        <div class="login-tip">*请输入华夏银行预留信息</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import useLogin from '../hooks/useLogin'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const router = useRouter()
    const {
      hadLogin,
      isLoginPopupVisble,
      mobile,
      credentials,
      validateLogin,
      onPopupLogin,
      onMobileInput,
      onCredentialsInput,
      onLogin,
      onPopupLogout
    } = useLogin()

    const onRoutePointseRecord = () => {
      router.push('/pointsRecord')
    }
    const onRouteExchagneRecord = () => {
      router.push('/exchangeRecord')
    }

    return {
      hadLogin,
      isLoginPopupVisble,
      mobile,
      credentials,
      validateLogin,
      onMobileInput,
      onPopupLogin,
      onCredentialsInput,
      onPopupLogout,
      onLogin,
      onRoutePointseRecord,
      onRouteExchagneRecord
    }
  }
}
</script>

<style lang="less" scoped>
.mine-tab {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;

  .mine__header {
    width: 375px;
    height: 195px;
    background: #d81c27;
    box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.19);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .mine__head {
      width: 103px;
      height: 103px;
      border-radius: 52px;
      background-color: #cccccc;
      overflow: hidden;
      img {
        width: 103px;
        height: 103px;
      }
    }
    .mine__name {
      font-size: 17px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      margin-top: 11px;
    }
    .mine__btn-login {
      position: absolute;
      width: 52px;
      height: 23px;
      background: #d03c45;
      border: 1px solid #ffffff;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      top: 10px;
      right: 10px;
    }
    .mine__btn-login:active {
      opacity: 0.5;
    }
  }
  .mine__content {
    flex: 1;
    position: relative;
    .mine__item {
      height: 60px;
      background: #ffffff;
      display: flex;
      align-items: center;
      margin-top: 8px;
      .mine__item-icon {
        width: 29px;
        height: 29px;
        background-image: url('../../../../assets/mine-icon.png');
        background-repeat: no-repeat;
        background-size: 100%;
        margin-left: 28px;
      }
      .mine__item-points-icon {
        width: 29px;
        height: 29px;
        background-image: url('../../../../assets/mine-points-icon.png');
        background-repeat: no-repeat;
        background-size: 100%;
        margin-left: 28px;
      }
      .mine__item-text {
        flex: 1;
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 15px;
        color: #333333;
        margin-left: 18px;
      }
      .mine__item-arrow {
        width: 12px;
        height: 19px;
        background-image: url('../../../../assets/mine-arrow.png');
        background-repeat: no-repeat;
        background-size: 100%;
        margin-right: 13px;
      }
    }
    .mine__item:active {
      opacity: 0.5;
    }
    .mine__tip {
      position: absolute;
      bottom: 60px;
      left: 0;
      width: 375px;
      .mine__tip-title {
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        text-align: center;
      }
      .mine__tip-content {
        font-size: 8px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        line-height: 13px;
        text-align: center;
        margin: 0 10px;
        margin-top: 5px;
      }
    }
  }
  .login-form {
    .login-title {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      text-align: center;
      margin-top: 26px;
    }
    .login-row {
      display: flex;
      align-items: center;
      margin-top: 17px;
      .login-label {
        min-width: 120px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #121212;
        text-align: right;
      }
      .login-input {
        width: 160px;
        height: 30px;
        background: #f2f2f2;
        border: 1px solid #cccccc;
        border-radius: 5px;
        padding: 0;
        padding-left: 3px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        -webkit-appearance: none;
      }
    }
    .login-tip {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ff2115;
      text-align: center;
      margin: 17px 0;
    }
  }
}
</style>
